// import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-folder.types';
import * as constants from './meeting-folder.constants';
import { Reducer, combineReducers } from 'redux';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IMeetingFoldersPageState = {
  meetingFoldersIds: [],
};

const meetingsFolderReducer: Reducer<
  types.IMeetingFoldersPageState['meetingFoldersIds'],
  types.IStoreMeetingFolder | types.IClearMeetingFolder
> = (state = initialState.meetingFoldersIds, action) => {
  if (isActionOfType<types.IStoreMeetingFolder>(action, constants.STORE_MEETING_FOLDER_IDS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearMeetingFolder>(action, constants.CLEAR_MEETING_FOLDER)) {
    return initialState.meetingFoldersIds;
  }

  return state;
};

export const meetingFoldersPageReducer: Reducer<
  types.IMeetingFoldersPageState,
  types.IMeetingFoldersPageAction
> = combineReducers({
  meetingFoldersIds: meetingsFolderReducer,
});
